import React, { useEffect, useRef } from "react";
import "./Toast.scss";

function Toast({ closeToast = () => {}, showToast = false, toastText = "" }) {
  const toastRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        toastRef.current &&
        !toastRef.current.contains(event.target) &&
        showToast
      ) {
        closeToast();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showToast]);

  return (
    <>
      {showToast && (
        <div
          id="toastAlert"
          className="toast--success"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          ref={toastRef}
        >
          <div className="wrapper">
            <div className="toast-header">
              <strong>{toastText}</strong>
              <button
                type="button"
                data-dismiss="toast"
                aria-label="Close"
                onClick={closeToast}
              ></button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Toast;
